import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";

export default function Sidebar() {
  const { user } = useContext(AuthContext);
  return (
    <div className="ec-shop-leftside ec-vendor-sidebar col-lg-3 col-md-12">
      <div className="ec-sidebar-wrap">
        <div className="ec-sidebar-block">
          <div className="ec-vendor-block">
            <div className="ec-vendor-block-items">
              <ul>
                <li>
                  <Link to="/admin/dashboard">Dashboard</Link>
                </li>
                <li>
                  <Link to="/admin/users">Users</Link>
                </li>
                <li>
                  <Link to="/admin/user-log">User log</Link>
                </li>
                <li>
                  <Link to="/admin/customers">Customers</Link>
                </li>
                {(user.userType === "Super Admin" || user.isShowSample) && (
                  <li>
                    <Link to="/admin/sample-categories">Sample categories</Link>
                  </li>
                )}

                <li>
                  <Link to="/admin/stock-categories">Stock categories</Link>
                </li>
                {(user.userType === "Super Admin" || user.isShowSample) && (
                  <li>
                    <Link to="/admin/sample-products">Sample Products</Link>
                  </li>
                )}

                <li>
                  <Link to="/admin/stock-products">Stock Products</Link>
                </li>
                <li>
                  <Link to="/admin/banner-images">Banner Images</Link>
                </li>
                <li>
                  <Link to="/admin/orders">Orders</Link>
                </li>
                {(user.userType === "Super Admin" ||
                  user.isShowPersonalizedProducts) && (
                  <li>
                    <Link to="/admin/personalized-users">Personalized</Link>
                  </li>
                )}

                <li>
                  <Link to="/admin/customer-cart-list">Customer Cart list</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
